import { lazy, Suspense } from 'react';
import Hero from './components/Hero';
import Navigation from './components/Navigation';
import SeoSchemas from '../../components/feature/SeoSchemas';

const Listings = lazy(() => import('./components/Listings'));
const Amenities = lazy(() => import('./components/Amenities'));
const PhotoGallery = lazy(() => import('./components/PhotoGallery'));
const GuestReviews = lazy(() => import('./components/GuestReviews'));
const WhyAustin = lazy(() => import('./components/WhyAustin'));
const LocationMap = lazy(() => import('./components/LocationMap'));
const FAQ = lazy(() => import('./components/FAQ'));
const Contact = lazy(() => import('./components/Contact'));

function SectionFallback() {
  return <div className="py-24 bg-white" aria-hidden="true" />;
}

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoSchemas />
      <Navigation />
      <Hero />
      <Suspense fallback={<SectionFallback />}>
        <Listings />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Amenities />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <PhotoGallery />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <GuestReviews />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <WhyAustin />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <LocationMap />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <FAQ />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Contact />
      </Suspense>
    </div>
  );
}
